export default __webpack_public_path__ + "static/media/11-la-prena.c193ef6f.png";